import { Component, Input } from '@angular/core';

@Component({
  selector: 'fcp-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {

  @Input() public index: number;

  constructor() {
    if (!this.index) {
      this.index = 0;
    }
  }

}
